import { Typography } from '@material-ui/core';
import {
  categorizeOrderInsightRisks,
  getParentSeverity,
  PropertyOrderInsightsProps,
  RiskCategory,
} from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import React from 'react';
import OrderInsightAlert from './OrderInsightAlerts';
import OrderInsightsRiskIcon from './OrderInsightsRiskIcon';
import orderInsightStyles from './OrderInsightStyles';

const RecordedPropertyInfo: React.FC<PropertyOrderInsightsProps> = ({ property, isPdf }) => {
  const addressComponents = [
    property.address?.address1,
    property.address?.address2,
    property.address?.city,
    property.address?.stateOrProvince,
    property.address?.postalCode,
  ];
  const fullAddress = addressComponents.filter(Boolean).join(', ');
  const { alertRisks, warningRisks, unknownRisks, errorRisks } = categorizeOrderInsightRisks(
    property.risks,
    RiskCategory.PropertyInfo,
  );
  const classes = orderInsightStyles();

  return (
    <div className={classes.brdBtm}>
      <div className={clsx(classes.displayFlex, classes.flexGrow)}>
        <div className={classes.labelCol}>
          <span className={clsx(classes.displayFlex, classes.alignCenter)}>
            <OrderInsightsRiskIcon
              isPdf={isPdf}
              riskSeverity={getParentSeverity(property.risks, RiskCategory.PropertyInfo)}
            />
            <Typography
              variant="h4"
              color="textSecondary"
              className={clsx(classes.ml1, classes.fontSizeNormal, isPdf ? classes.bold : '')}
            >
              Recorded Property Info:
            </Typography>
          </span>
        </div>
        <div className={classes.flexGrow}>
          <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
            <strong className={classes.minWidth}>Address:</strong> {fullAddress || ''}
          </Typography>
          <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
            <strong className={classes.minWidth}>APN:</strong> {property.apn || ''}
          </Typography>
          <Typography variant="body1" className={clsx(classes.mb1, classes.fontSizeNormal)}>
            <strong className={classes.minWidth}>Property Type:</strong> {property.propertyType || ''}
          </Typography>
          <OrderInsightAlert
            isPdf={isPdf}
            alerts={alertRisks}
            warnings={warningRisks}
            unknowns={unknownRisks}
            errors={errorRisks}
          />
        </div>
      </div>
    </div>
  );
};

export default RecordedPropertyInfo;
